<template>
  <div class="home-page spin-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
    <div class="content" style="padding-bottom: 0;">
      <div style="text-align: center">
        <img src="static/images/spin_title.png" style="width:72%;">
      </div>
      <div class="crfff spin-content" >
        <div class="box-lottery ">
          <div class="lottery-wrap" :style="wrapStyle">
          <span
            v-for="(item, index) in lotteryItems"
            :key="item.id"
            :class="'lottery-span' + (index + 1)"
            :data-id="item.id"
          >
            <i>{{ item.name }}</i>
          </span>
          </div>
          <a class="lottery-btn" href="javascript:void(0);" @click="startLottery">
            <span
              style="color:#fff;position: relative;font-weight: 700;z-index: 1000;text-align: center;display: flex;justify-content: center;align-items: center;height: 1.8rem;font-size: 0.2rem;">{{ $t('spin') }}</span>
          </a>
        </div>
        <div class="ac">
          <img src="../../static/images/bg_lottery_b.png" style="width: 2.8rem">
        </div>
                <div class="ac" style="text-shadow: 0.01rem 0.03rem 0px #000;">{{$t('SpinChances')}}: {{pinNum}}</div>
      </div>
      <div class="winlist winlist-box" :class="{'active':isShow}">
        <div class="bg" v-if="isShow"></div>
        <div class="winlist-c">
          <div class="nav ac" style="margin-bottom: 0.7rem;" v-if="isShow">{{ $t('WinnerList') }}</div>
          <div class="up ac" :class="{'spin-down':isShow}" @click="getUp"><img width="30" src="../../static/images/up.png"></div>
          <div class="winlist-bg">
            <div class="disflex win-title" style="justify-content: space-between;">
              <span>{{ $t('date') }}</span>
              <span>{{ $t('phoneNumber') }}</span>
              <span>{{ $t('Prizes') }}</span>
            </div>
            <div class="prize-content">
              <div class="prize-list disflex" v-for="(item,index) in prizeList" :key="index">
                <div class="">{{ item.date }}</div>
                <div class="">{{ item.mobile }}</div>
                <div class="">{{ item.prize_name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog ref="saveDialog" title="" type="alert" :modalFoot="modalFoot" :bgC="modalFoot" :cancelText="$t('No')">
        <div slot="mdBox">
          <div class="spin-c ac disflex fs33">
            <div class="" style="width:100%;">
              <div style="margin-top: 0.8rem">
                <div class="jiang">{{ jiang }}</div>
                <img style="width: 60%;margin-top: 0.3rem" src="static/images/jiang.png"/>
              </div>
              <div style="margin: auto 0.8rem">
                <div class="fs40" style="font-size: 0.3rem">{{ $t('win_tip') }}</div>
              </div>
              <div class="modal-footer ac">
                <button class="btn btn-yellow" id="closeModal" @click="confirm">{{ $t('Confirm') }}</button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>

</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import anime from "animejs";

export default {
  components: {
    Header,
    Dialog
  },
  name: "Lottery",
  data() {
    return {
      modalFoot: false,
      lotteryItems: [],
      wrapStyle: {transform: "rotate(45deg)"},
      isPlaying: false,
      animeInstance: null,
      jiang: '',
      pinNum: null,
      prizeList: [],
      isShow: false,
      num: 0
    };
  },
  created() {
    this.getList();
    this.getPinNum();
  },
  methods: {
    getUp() {
      this.isShow = !this.isShow;
    },
    getBuy() {
      let that = this;
      let data = {
        'token': localStorage.getItem('token'),
        answer_category_id: 1,
        uuid: localStorage.getItem('uuid')
      };

      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          that.$utils.alertText(that.$t('Purchasefailed'), 0.8);
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$refs.buyDialog.showMaskFun();
          that.getPinNum();
        });
      });
    },
    back() {
      this.$router.go(-1);
    },
    getPinNum() {
      let that = this;
      let data = {'token': localStorage.getItem('token'), uuid: localStorage.getItem('uuid')};
      that.$api.post('/api/prize/draw_num', data, r => {
        that.$parent.returnCode(r, function () {
          that.pinNum = r.data.draw_num;
        });
      });
    },
    confirm() {
      this.$refs.saveDialog.closeMask();
      this.$refs.buyDialog.closeMask();
    },
    getList() {
      let that = this;
      let data = {'token': localStorage.getItem('token'), uuid: localStorage.getItem('uuid')};
      that.$api.post('/api/prize/list', data, r => {
        that.$parent.returnCode(r, function () {
          that.lotteryItems = r.data.prize;
        });
      });
      that.$api.post('/api/prize/win', data, r => {
        that.$parent.returnCode(r, function () {
          that.prizeList = r.data.list;
        });
      });
    },
    startLottery() {
      let that = this;
      if (this.isPlaying) return;

      let data = {'token': localStorage.getItem('token'), uuid: localStorage.getItem('uuid')};
      that.$api.post('/api/prize/lottery', data, r => {
        if (r.code == 70001) {
          that.$utils.alertText(that.$t('nochance'), 80);
          return;
        }
        that.$parent.returnCode(r, function () {
          that.jiang = r.data.name;
          that.pinNum = r.data.draw_num;
          if (!that.animeInstance) {
            that.animeInstance = anime({
              targets: ".lottery-wrap",
              autoplay: false
            });
          }
          that.rotateTurntable(r.data.id - 2, () => {
            if(r.data.name == 'none'){
              that.$utils.alertText(that.$t('not_win'), 80);
              return;
            }
            that.$refs.saveDialog.showMaskFun();
          });
        });
      });
    },
    rotateTurntable(index, callback) {
      this.num++;
      this.isPlaying = true;

      const total = this.lotteryItems.length;
      const angle = 360 / total;
      const rotateNum = 5;
      const offset = 0;
      let off = (total - index) * angle - angle / 2 - offset;
      // Reset animation if needed
      if (this.animeInstance) {
        this.animeInstance.seek(0);
      }
      this.animeInstance = anime({
        targets: ".lottery-wrap",
        easing: "easeInOutSine",
        duration: 3000,
        rotate: rotateNum * 360 + off,
        complete: () => {
          this.wrapStyle.transform = `rotate(${off}deg)`;
          this.isPlaying = false;
          if (callback && typeof callback === 'function') {
            callback();
          }
        }
      });
    }
  },
  mounted() {
    // Initialize anime.js instance
    this.animeInstance = anime({
      targets: ".lottery-wrap",
      autoplay: false
    });
  }
};
</script>

<style scoped>
/* 样式 */
.winlist {
  //margin-top: 0.6rem;
}

.winlist-bg {
  background: #fff;
  border-radius: 0.2rem;
  color: #440db1;
  margin: 0 0.2rem;
  padding: 0.2rem;
}

.prize-content {
  max-height: 2rem;
  overflow: hidden;
  text-shadow: 0 0 #000;
}

.win-title {
  background: #5e32ff;
  padding: 0.2rem 0.2rem;
  color: #fff;
  font-weight: 700;
  border-radius: 0.2rem;
  font-size: 0.28rem;
  margin-bottom: 0.1rem;
}

.up {
  margin: 0.2rem 0;
}

.spin-down {
  transform: rotate(180deg);
}

.prize-list {
  justify-content: space-between;
  padding: 0.1rem 0;
}

.prize-list div {
  width: 33.33%;
}

.bg {
  background: #0000008a;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1000;
}

.winlist-box.active .winlist-c {
  position: fixed;
  bottom: 0;
  z-index: 1001;
  width: 100%;
}

.active .prize-content {
  max-height: calc(100vh - 6.2rem);
  overflow-y: scroll;
}

.box-lottery {
  position: relative;
  margin: 0.3rem auto 0;
  width: 6.41rem;
  height: 6.41rem;
  background: url('../../static/images/bg_lottery_f.png') center no-repeat;
  overflow: hidden;
  background-size: cover;
}

.lottery-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('../../static/images/bg_lottery_f.png') center no-repeat;
  background-size: cover;
}

.lottery-wrap img {
  width: 0.93rem;
  height: 0.69rem;
}

.lottery-wrap span {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 32.7%;
  width: 2.14rem;
  height: 50%;
  color: #fff;
  -webkit-transform-origin: 50% 100%;
  -moz-transform-origin: 50% 100%;
  -ms-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  text-align: center;
}

.lottery-wrap span.lottery-span1 {
  -webkit-transform: rotate(22.5deg);
  -moz-transform: rotate(22.5deg);
  -ms-transform: rotate(22.5deg);
  transform: rotate(22.5deg);
}

.lottery-wrap span.lottery-span2 {
  -webkit-transform: rotate(67.5deg);
  -moz-transform: rotate(67.5deg);
  -ms-transform: rotate(67.5deg);
  transform: rotate(67.5deg);
}

.lottery-wrap span.lottery-span3 {
  -webkit-transform: rotate(112.5deg);
  -moz-transform: rotate(112.5deg);
  -ms-transform: rotate(112.5deg);
  transform: rotate(112.5deg);
}

.lottery-wrap span.lottery-span4 {
  -webkit-transform: rotate(157.5deg);
  -moz-transform: rotate(157.5deg);
  -ms-transform: rotate(157.5deg);
  transform: rotate(157.5deg);
}

.lottery-wrap span.lottery-span5 {
  -webkit-transform: rotate(202.5deg);
  -moz-transform: rotate(202.5deg);
  -ms-transform: rotate(202.5deg);
  transform: rotate(202.5deg);
}

.lottery-wrap span.lottery-span5 img {
  width: 0.71rem;
  height: 0.71rem;
}

.lottery-wrap span.lottery-span6 {
  -webkit-transform: rotate(247.5deg);
  -moz-transform: rotate(247.5deg);
  -ms-transform: rotate(247.5deg);
  transform: rotate(247.5deg);
}

.lottery-wrap span.lottery-span6 img {
  width: 0.8rem;
  height: 0.55rem;
}

.lottery-wrap span.lottery-span7 {
  -webkit-transform: rotate(292.5deg);
  -moz-transform: rotate(292.5deg);
  -ms-transform: rotate(292.5deg);
  transform: rotate(292.5deg);
}

.lottery-wrap span.lottery-span8 {
  -webkit-transform: rotate(337.5deg);
  -moz-transform: rotate(337.5deg);
  -ms-transform: rotate(337.5deg);
  transform: rotate(337.5deg);
}

.lottery-wrap span:nth-child(3n + 1) {
  color: #ff0000;
}

.lottery-wrap span:nth-child(3n + 2) {
  color: #00ff00;
}

.lottery-wrap span:nth-child(3n + 3) {
  color: #0000ff;
}

.lottery-wrap i {
  transform: rotate(263deg);
  display: block;
  width: 100%;
  font-style: normal;
  font-size: 0.22rem;
  line-height: 0.32rem;
  color: #fee1e1;
  margin: 1.18rem 0 0.12rem;
  opacity: 0;
}

.lottery-wrap img {
  max-width: 100%;
}

.lottery-btn {
  position: absolute;
  left: 51%;
  top: 49%;
  z-index: 11;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.61rem;
  height: 1.61rem;
}

.box-lottery .jian {
  position: absolute;
  z-index: 20;
  top: -0.3rem;
  left: 50%;
  margin-left: -0.205rem;
  width: 0.6rem;
  height: 1.02rem;
  background: url('../../static/images/icon_point.png') center no-repeat;
  -webkit-transform-origin: 50% 1.025rem;
  -moz-transform-origin: 50% 1.025rem;
  -ms-transform-origin: 50% 1.025rem;
  transform-origin: 50% 1.025rem;
}

.lottery-btn:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('../../static/images/btn_lottery_1.png') center no-repeat;
  background-size: cover;
  transform: rotate(22.5deg);
}

.spin-c {
  background: url('../../static/images/tan.png') center no-repeat;
  background-size: cover;
  width: 6.47rem;
  height: 8.91rem;
  border-radius: 1.1rem;
}

.gx {
  text-shadow: 0.01rem 0.03rem 0px #000;
  font-size: 0.2rem;
  color: #fff
}

.jiang {
  border: 0.04rem solid #fff;
  display: inline-block;
  padding: 0.05rem 0.3rem;
  border-radius: 1.2rem;
  margin: 0.2rem 0;
  position: relative;
}

.jiang::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 0.15rem solid transparent;
  border-right: 0.15rem solid transparent;
  border-top: 0.24rem solid #fff;
  bottom: -0.26rem;
  position: absolute;
  margin-left: -0.16rem;
  left: 50%;
}

.buypin {
  width: 3.49rem;
  height: 1.08rem;
  background: url('../../static/images/buypin.png') center no-repeat;
  font-size: 0.3rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.2rem auto;
}

.spin-page {
  background: url('../../static/images/bg2.jpg') center no-repeat;
  min-height: 100%;
  background-size: cover;
}

#closeModal {
  background: url('../../static/images/spin_claim.png') center no-repeat;
  min-height: 100%;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/page/spin.vue